import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "../Popup/Popup";

interface Props {
	onHomePressed: Function;
	refNumber?: string;
}

interface State {
}

class ValuationSuccessPopUp extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {} as State;
	}

	render() {
		return <Popup
			showCloseButton={ false } clickOutsideToDismiss={ false }
			modalSubContainer={ "modal-dialog modal-dialog-centered" }
			id={ "SuccessMsgExternalValuation" } title={ Strings.confirmation }
			showIcon={ false } modalBodyContainer="">
			<div className="modal-body">
				<div>
					<div className="check-icon">
						<i className="fa fa-check"></i>
					</div>
					<p className="text-center">
						{ Strings.request_sent_successfully }
					</p>
					<p className="text-center">
						{ Strings.track_request }
					</p>
					{
						this.props.refNumber && <div className="refn-box">
							{ Strings.reference_number + ":" } <span>{ this.props.refNumber }</span>
						</div>
					}
				</div>
			</div>

			<div className="modal-footer justify-content-center">
				<button
					onClick={ () => {
						this.props.onHomePressed();
					} } type="button" className="btn btn_1 btn_style1"
					data-bs-dismiss="modal">{ Strings.home }</button>
			</div>
		</Popup>;
	}
}

export default ValuationSuccessPopUp;
